module.exports = __webpack_public_path__ + "img/others-safe.91eabcc4.svg";